import { ThunderboltOutlined } from "@ant-design/icons";
import React from "react";
import { openOrCloseModalSnippets } from "../../../../../hooks/automation";
import { connect } from "react-redux";
import { Button } from "antd";

/**
 * `wholeField`: o campo consome a lista inteira do campo de formulário, não um
 * valor dela — é o caso do valor avaliado pelo desvio (que compara contra todos
 * os itens) e do valor de referência do laço (que percorre a lista). Nesses, a
 * anotação entra como a raiz do campo, sem o caminho até o `value`.
 */
const IconTriggerModal = ({ fieldName, fieldLabel, onOpenOrCloseModalSnippets, withButton = false, isCode = false, acceptEntryLoop = true, wholeField = false }) => {

    const openModal = () => onOpenOrCloseModalSnippets({
        action: true,
        fieldName,
        fieldLabel,
        isCode,
        acceptEntryLoop,
        wholeField
    });

    const icon = (<ThunderboltOutlined style={{ cursor: "pointer" }} onClick={openModal} />);
    if (withButton) {
        return (
            <Button onClick={openModal}>
                {
                    icon
                }
            </Button>
        )
    }
    return (icon)
}

const mapDispatchToProps = (dispatch) => {
    return {
        onOpenOrCloseModalSnippets: ({ action, fieldName, fieldLabel, isCode, acceptEntryLoop, wholeField }) => dispatch(openOrCloseModalSnippets({
            action,
            fieldName,
            fieldLabel,
            isCode,
            acceptEntryLoop,
            wholeField
        })),
    };
};
const mapStateToProps = ({ }) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(IconTriggerModal);
